import { useMemo } from 'react';

import { useData } from '@/common/dataContext';
import {
  getCompanyBrandFromPreferences,
  type KincodeButtonTheme,
} from '@/utils/companyBrand';

export type UseCompanyBrandResult = {
  colorHex: string;
  buttonTheme: KincodeButtonTheme;
};

/**
 * Company brand color and derived KincodeButton theme from `colorHex` (not `personalization.theme`).
 */
export function useCompanyBrand(): UseCompanyBrandResult {
  const { companyPreferences } = useData();

  return useMemo(
    () => getCompanyBrandFromPreferences(companyPreferences),
    [companyPreferences]
  );
}
